import { Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { Button, Input, Space, Typography, Modal } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  Container,
  PokeList,
  PokeItem,
  ItemCard,
  PokeImg,
  ItemData,
  Row,
  QuantityCircle,
  MinusButton,
} from "./styles";
import { useMediaQuery } from "react-responsive";
import { useState } from "react";
import { useListarObjetos, useConsumirObjetos } from "../../../Hooks/Player";


const { Title } = Typography;

export const ObjetosScreen = () => {

  const {data, refetch, isFetching} = useListarObjetos({ search: '' });
  const [searchObjeto, setSearchObjeto] = useState(null)
  const apiConsumirObjeto = useConsumirObjetos();

  const [prueba, setPrueba] = useState([
    {
      id: 1,
      nombre: "Piedra Agua",
      descripcion: "Piedra peculiar que hace evolucionar a ciertos Pokémon. Es azul y tiene forma de gota de agua.",
      cantidad: 3,
      consumible: false,
      imagen:
        "https://images.wikidexcdn.net/mwuploads/wikidex/1/14/latest/20230106130249/Piedra_agua_EP.png",
    },
    {
      id: 2,
      nombre: "Poción",
      descripcion: "Restablece los PS de un Pokémon en 3 puntos.",
      cantidad: 5,
      consumible: true,
      imagen:
        "https://images.wikidexcdn.net/mwuploads/wikidex/f/fd/latest/20230115173615/Poci%C3%B3n_EP.png",
    },
    {
      id: 3,
      nombre: "Cura Total",
      descripcion: "Cura todos los problemas de estado de un Pokémon.",
      cantidad: 3,
      consumible: true,
      imagen:
        "https://images.wikidexcdn.net/mwuploads/wikidex/d/df/latest/20230123181503/Cura_total_EP.png",
    },
  ])

  const consumirObjeto = async (objeto) => {

    await apiConsumirObjeto.mutateAsync({idObjetoUsuario: objeto.id});
    refetch();
    setDataObjeto(null)
   /*  setPrueba((prevState) =>
      prevState
        .map((item) => {
          if (item.id === objeto.id) {
            return { ...item, cantidad: item.cantidad - 1 }; // Descontar 1 a la cantidad
          }
          return item;
        })
        .filter((item) => item.cantidad > 0) // Filtrar objetos con cantidad mayor que 0
    );
    ; */
  
  };


  const navigate = useNavigate();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

 



  const [dataObjeto, setDataObjeto] = useState(null);
  const showModal = (objeto) => {
    setDataObjeto(objeto);
  };

  const searchObjetos = () => {
    refetch({search: searchObjeto});
  }  

  return (
    <>
      {isDesktopOrLaptop ? (
        navigate("/404")
      ) : (
        <Flex justify="center" align="center">
          <Container>
            <div style={{ width: "100%" }}>
              <Typography
                direction="vertical"
                style={{
                  marginTop: "5%",
                  marginLeft: "5%",
                }}
              >
                <Row>
                  <Title
                    level={1}
                    style={{ marginTop: "0%", fontFamily: "POKEFONT" }}
                  >
                    Objetos
                  </Title>
                </Row>
              </Typography>
            </div>

            <Space.Compact style={{ width: "90vw", marginBottom: "20px" }}>
              <Input
                size="large"
                placeholder="Qué Objeto necesitas?"
                prefix={<SearchOutlined />}
                style={{ borderRadius: "25px 0 0 25px" }}
                onChange={(e) => setSearchObjeto(e.target.value)}
              />
              <Button
                size="large"
                style={{
                  borderRadius: "0 25px 25px 0",
                  width: "20%",
                  backgroundColor: "rgb(44, 62, 80)",
                  color: "white",
                }}
                onClick={searchObjetos}
              >
                Buscar
              </Button>
            </Space.Compact>

            <PokeList>
              {data && data.map((objeto) => (
                <PokeItem key={objeto.id} onClick={() => showModal(objeto)}>
                  <ItemCard>
                    <div style={{ position: "relative" }}>
                      <PokeImg src={objeto.imagen} alt={objeto.nombre} />
                      <QuantityCircle>{objeto.cantidad}</QuantityCircle>
                    </div>
                    <ItemData>
                      <div
                        style={{
                          backgroundColor: "rgb(44, 62, 80)",
                          borderRadius: "5px",
                        }}
                      >
                        <Typography.Text
                          style={{ fontWeight: "600", color: "#FFFF" }}
                        >
                          {objeto.nombre}
                        </Typography.Text>
                      </div>
                    </ItemData>
                  </ItemCard>
                </PokeItem>
              ))}
          
            </PokeList>
          </Container>

          <Modal
            visible={dataObjeto ? true : false}
            footer={null}
            closable={false}
            onCancel={() => setDataObjeto(null)}
            className="custom-modal"
            style={{
              backgroundColor: "transparent",
              padding: "10px",
            }}
          >
            {dataObjeto && (
              <div style={{ padding: "20px", borderRadius: "10px" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={dataObjeto.imagen}
                    //alt={dataObjeto.nombre}
                    style={{ width: "50%" }}
                  />
                </div>
                <p
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
                  }}
                >
                  "{dataObjeto.descripcion}"
                </p>
                {dataObjeto.consumible && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      size="large"
                      type="primary"
                      danger
                      style={{ padding: "1,5rem", width: "60%", fontWeight:"bold" }}
                      onClick={() => Modal.confirm({
                        title: "Utilizar objeto",
                        content: "¿Estas seguro que quieres utilizar el objeto?",
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                        onOk: () => consumirObjeto(dataObjeto),
                      })}
                    >
                      UTILIZAR
                    </Button>
                  </div>
                )}
              </div>
            )}
          </Modal>
        </Flex>
      )}
    </>
  );
};
